import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, take } from "rxjs/operators";

import { BLOBS_SERVICE_URL } from "environments/config";

@Injectable()
export class BlobService {
  constructor(private http: HttpClient) {}

  uploadFile(file: File) {
    const data = new FormData();
    data.append("file", file, file.name);
    return this.http.post<any>(`${BLOBS_SERVICE_URL}/`, data).pipe(
      take(1),
      map((response) => response)
    );
  }
}
